import {RouteConfig} from 'vue-router';
import store from '@/store';
import {MenuItem} from '@/store/types';

/**
 * Rutas del módulo de internacionalización
 */
export function routes (): RouteConfig[] {
    const singleLanguage = store.state.config.get('i18n.singleLanguage', false)
    const routes = [
        {
            name: 'i18n.translations',
            path: singleLanguage ? '/textos' : '/i18n/idioma/:locale/traducciones',
            component: () => import('@/modules/i18n/components/MessageList.vue'),
            meta: {
                toolbarTitle: singleLanguage ? 'Textos de la web' : 'Traducciones',
                authRequired: true,
                module: 'i18n.translations',
                vuex: {
                    loadModules: ['i18n', 'media'],
                    dispatch: ['i18n/loadWorldLocales'],
                },
            },
        },
    ]

    // Si no se ha activado el modo mono-idioma se carga la ruta para acceder a
    // la lista de idiomas registrado en la aplicación
    if (!singleLanguage) {
        routes.push({
            name: 'i18n.locales',
            path: '/i18n/idiomas-regiones',
            component: () => import('@/modules/i18n/components/LocaleList.vue') as any,
            meta: {
                toolbarTitle: 'Idiomas y regiones',
                authRequired: true,
                module: 'i18n.locales',
                vuex: {
                    loadModules: ['i18n', 'media'],
                    dispatch: ['i18n/loadWorldLocales'],
                },
            },
        })
    }

    return routes
}


/**
 * Declara el menú del módulo de traducciones
 */
export function menu (): MenuItem[] {
    const singleLanguage = store.state.config.get('i18n.singleLanguage', false)
    if (singleLanguage) {
        return [
            {
                title: 'Textos de la web',
                icon: 'list',
                routeName: 'i18n.translations',
                requireAuthorization: true,
                permission: '@/i18n/admin',
            },
        ]
    }

    // Carga el menú completo del módulo de traducciones, el usuario podrá acceder
    // a la edición de idiomas y traducciones
    return [
        {
            title: 'Internacionalización',
            icon: 'mdi-translate',
            requireAuthorization: true,
            permission: '@/i18n/admin',
            children: [
                {
                    title: 'Idiomas y regiones',
                    icon: 'mdi-flag',
                    routeName: 'i18n.locales',
                    requireAuthorization: true,
                    permission: '@/i18n/admin/locales',
                },
                {
                    title: 'Traducciones',
                    icon: 'mdi-format-list-bulleted',
                    routeName: 'i18n.translations',
                    requireAuthorization: true,
                    permission: '@/i18n/admin/translations',
                    params: {
                        locale: '__',
                    },
                },
            ],
        },
    ]
}

